import { ComponentProps, TSitecoreContext } from '../../../../types/types';
import { ctaTypes } from '../../cta';

export const CtaStylesCtaTypeObj = {
  'Primary Red': ctaTypes['primaryRed'],
  'Primary White': ctaTypes['primaryWhite'],
  'Primary Black': ctaTypes['primaryBlack'],
  'Secondary Red With Icon': ctaTypes['secondaryRed'],
  'Secondary White With Icon': ctaTypes['secondaryWhite'],
};

export type TGenericPopUpParams = Partial<{
  ctaText: string;
  ctaStyles: keyof typeof CtaStylesCtaTypeObj;
}>;

export type TGenericPopUpProps = ComponentProps<{ isComponentUnreleased?: boolean }, TGenericPopUpParams> & {
  sitecoreContext?: TSitecoreContext;
  extraClassName?: string;
  children?: any;
};
